import { Keyboard } from "./Keyboard.ts";
import { Entity } from "./Entity.ts";
import { BULLET_LIFETIME, DRAG, SHOOT_TIMEOUT, TICKS } from "./config.ts";
import { Vector2 } from "./Vector2.ts";
import { CollisionEvent } from "./CollisionEvent";
import { Game } from "./Game";

export class EntityController extends AbortController {
  interval: number;
  last_bullet = 0;

  constructor(
    readonly model: Entity,
    readonly game: Game,
  ) {
    super();
    this.interval = setInterval(this.step.bind(this), 1000 / TICKS);
  }

  step() {
    this.updateControl();
    this.updateDrag();
    this.shoot();
  }

  updateControl() {
    this.model.angle_velocity = Keyboard.x * -0.1;
    this.model.forces.control = Vector2.angle(this.model.angle).mul(Keyboard.y);
  }

  updateDrag() {
    const { velocity, forces } = this.model;
    const drag = new Vector2();
    if (Math.abs(velocity.x) < 0.01) velocity.x = drag.x = 0;
    else if (velocity.x < 0) drag.x = DRAG;
    else drag.x = -DRAG;
    if (Math.abs(velocity.y) < 0.01) velocity.y = drag.y = 0;
    else if (velocity.y < 0) drag.y = DRAG;
    else drag.y = -DRAG;
    forces.drag = drag;
  }

  shoot() {
    if (!Keyboard.space) return;
    if (Date.now() - this.last_bullet < SHOOT_TIMEOUT) return;
    this.last_bullet = Date.now();
    this.game.createBullet();
  }

  abort() {
    super.abort();
    clearInterval(this.interval);
  }
}
